import React, {Component} from 'react';

import InputMask from 'react-input-mask';
import swal from 'sweetalert2';

import Datepicker from "../../../../components/Datepicker/datepicker";
import PlateInput from "../../../../components/PlateInput/plateInput";
import {ajaxHandler} from "../../../../utils/errors";
import axios from "axios/index";
import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import validators from "../../../../utils/validators";
import {Spinner} from "../../../../components/Loading/Spinner";
import translator from "../../../../utils/translations";
import _ from "lodash";

export default class TripProgrammingForm extends Component {

    constructor(props) {
        super(props);

        let {trip} = props;

        this.state = {
            id: trip.id,
            ajaxInProgress: false,
            providers: false,
            products: false,
            terminals: false,
            product: trip.product.id,
            order_volume: trip.order_volume,
            terminal: trip.terminal.id,
            provider: trip.provider.id,
            line_number: trip.line_number,
            st_number: trip.st_number,
            st_company: trip.st_company,
            carrier: trip.carrier,
            carrier_doc: trip.carrier_doc,
            driver_name: trip.driver_name,
            driver_doc: trip.driver_doc,
            estimated_load_date: trip.estimated_load_date,
            truck_id: trip.truck_id,
            truck_plate: trip.truck_plate,
            trailer_plate: trip.trailer_plate,
        }
    }

    componentDidMount() {
        this._fetchFiltersOptions();
    }

    _initializeHTML = () => {
        window.initializeSelects('body');
        window.bindSelectAction(this.productSelect, this._handleSelect);
        window.bindSelectAction(this.terminalSelect, this._handleSelect);
        window.bindSelectAction(this.providerSelect, this._handleSelect);
    };

    _handleSelect = (ev) => {
        let target = ev.target;
        this.setState({
            [target.getAttribute('data-state-var')]: target.value
        });
    };

    _handleInput = (prop, value) => {

        // Custom validations
        if (prop === 'carrier_doc') {
            value = value.replace(/-/g, '');
        }

        let numbers = ['line_number', 'order_volume', 'provider_load_volume'];
        if (numbers.indexOf(prop) > -1) {
            value = validators.number(value);
        }

        this.setState({[prop]: value});
    };

    _handleDateChange = (prop, value) => {
        this.setState({[prop]: value });
    };

    _fetchFiltersOptions = () => {
        const provider = `${urls.API_ROOT}/api/v1/provider/`;
        const terminal = `${urls.API_ROOT}/api/v1/terminal/`;
        const product = `${urls.API_ROOT}/api/v1/product/`;
        axios.all([
            axios.get(provider, tokenHeader()),
            axios.get(terminal, tokenHeader()),
            axios.get(product, tokenHeader()),
        ])
            .then(axios.spread(function (prov, term, prod) {
                return {
                    providers: prov,
                    terminals: term,
                    products: prod
                }
            }))
            .then((data) => {
                this.setState({
                    providers: data.providers.data,
                    terminals: data.terminals.data,
                    products: data.products.data.filter(p => p.trip_type === 'FE')
                }, this._initializeHTML);
            })
            .catch((error) => ajaxHandler(error));
    };


    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let excludedKeys = ['id', 'providers', 'products', 'terminals', 'ajaxInProgress'];

        let data = _.omit(this.state, excludedKeys);
        Object.keys(data).forEach(key => {
            if (data[key] === '') {
                data[key] = null;
            }
            if (['truck_plate', 'trailer_plate', 'carrier_doc'].indexOf(key) > -1) {
                if (data[key])
                    data[key] = data[key].replace(/_/g, '');
            }
        });

        data['next_status'] = this.props.next_status;
        data['id'] = this.state.id;

        const UPDATE_SHIPMENT_URL = `${urls.API_ROOT}/api/v1/trip/id/${this.state.id}/`;
        axios.put(`${UPDATE_SHIPMENT_URL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(this._onSubmitError);

    };

    _onSubmitSuccess = () => {
        // let trip = response.data;

        swal({
            title: 'Viaje actualizado',
            html: 'El viaje ha sido actualizado correctamente. Espere unos segundos mientras lo redirigimos',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });

        setTimeout(this.props.reloadTrip, 3000);
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido actualizar el viaje',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    render() {
        let date = new Date();
        let date2 = new Date();
        let maxDate = new Date(date.setTime(date.getTime() + (24 * 60 * 60 * 1000 * 30)));
        let minDate = new Date(date2.setTime(date2.getTime() - (24 * 60 * 60 * 1000 * 30)));


        // Waiting for options
        if(!(this.state.products && this.state.provider && this.state.terminals)){
            return (
                <div className={"main-dashboard"}>
                    <div className={"valign-wrapper w100"} style={{height: '100%', minHeight: '300px'}}>
                        <Spinner />
                    </div>
                </div>

            );
        }

        return (
            <div className={"trip-section"}>
                <div className={"trip-section-title"}>Información del viaje</div>
                <div className={"row no-padding thin-row trip-form"}>
                    <div className={"col s6 no-padding"}>
                        <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                            <h4 className={'table-subtitle'}>Información Orden</h4>
                        </div>
                        <div className={"row margin-top-10"}>
                            <div className={"col s6 input-field"}>
                                <label className="active">Proveedor</label>
                                <select defaultValue={this.state.provider}
                                        data-state-var="provider" ref={ref => {
                                    this.providerSelect = ref
                                }}>
                                    <option value="">Seleccione proveedor</option>
                                    {this.state.providers && this.state.providers.map(provider => {
                                        return <option key={provider.id} id={provider.id}
                                                       value={provider.id}>{provider.business_name}</option>
                                    })}
                                </select>
                            </div>
                            <div className={"col s6 input-field"}>
                                <label className="active">Producto</label>
                                <select defaultValue={this.state.product}
                                        data-state-var="product" ref={ref => {
                                    this.productSelect = ref
                                }}>
                                    <option value="">Seleccione producto</option>
                                    {this.state.products && this.state.products.map(product => {
                                        return <option key={product.id} id={product.id}
                                                       value={product.id}>{product.name}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Tipo de viaje</label>
                                <p className={"field-p"}>Viaje FOB</p>
                            </div>
                            <div className={"col s6 input-field"}>
                                <label className="active">Destino</label>
                                <select defaultValue={this.state.terminal}
                                        data-state-var="terminal" ref={ref => {
                                    this.terminalSelect = ref
                                }}>
                                    <option value="">Seleccione destino</option>
                                    {this.state.terminals && this.state.terminals.map(terminal => {
                                        return <option key={terminal.id} id={terminal.id}
                                                       value={terminal.id}>{terminal.name}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Orden ST</label>
                                <input placeholder="Ingrese número ST" value={this.state.st_number}
                                       onChange={(ev) => this._handleInput('st_number', ev.target.value)}
                                />
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Cia ST</label>
                                <input placeholder={"Ingrese número ST"} value={this.state.st_company}
                                       onChange={(ev) => this._handleInput('st_company', ev.target.value)}/>
                            </div>
                        </div>
                        <div className={"row no-margin"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Número de Línea</label>
                                <input placeholder={"Ingrese numero de linea"} value={this.state.line_number}
                                       onChange={(ev) => this._handleInput('line_number', ev.target.value)}/>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Cantidad de Litros a 15º</label>
                                <input placeholder={"Ingrese cantidad"} value={this.state.order_volume}
                                       onChange={(ev) => this._handleInput('order_volume', ev.target.value)}/>
                            </div>
                        </div>
                    </div>
                    <div className={"col s6 no-padding"}>
                        <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                            <h4 className={'table-subtitle'}>Información Transporte</h4>
                        </div>
                        <div style={{borderLeft: '1px solid #404040', paddingLeft: 20}}>
                            <div className={"row margin-top-10"}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Empresa Transportista</label>
                                    <input placeholder={"Ingrese empresa"} value={this.state.carrier}
                                           onChange={(ev) => this._handleInput('carrier', ev.target.value)}
                                    />
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">C.U.I.T</label>
                                    <InputMask placeholder={"Ingrese CUIT"} value={this.state.carrier_doc}
                                               mask={'99-99999999-9'}
                                               onChange={(ev) => this._handleInput('carrier_doc', ev.target.value)}
                                    />
                                </div>
                            </div>
                            <div className={"row"}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Chofer - Nombre y Apellido</label>
                                    <input placeholder={"Ingrese nombre del chofer"} value={this.state.driver_name}
                                           onChange={(ev) => this._handleInput('driver_name', ev.target.value)}
                                    />
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Licencia de Conducir</label>
                                    <input placeholder={"Ingrese licencia"} value={this.state.driver_doc}
                                           onChange={(ev) => this._handleInput('driver_doc', ev.target.value)}/>
                                </div>
                            </div>
                            <div className={"row"}>
                                <div className={"col s6 input-field "}>
                                    <label className="active">Fecha estimada de Carga</label>
                                    <Datepicker classname="input-grey" placeholder={"Ingrese fecha"} max={maxDate}
                                                min={minDate}
                                                value={this.state.estimated_load_date} format={"YYYY-MM-DD"}
                                                id="estimated_load_date" action={this._handleDateChange}/>
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Transporte Unidad</label>
                                    <input placeholder={"Ingrese unidad"} value={this.state.truck_id}
                                           onChange={(ev) => this._handleInput('truck_id', ev.target.value)}/>
                                </div>
                            </div>
                            <div className={"row no-margin"}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Patente Chasis</label>
                                    <PlateInput
                                        placeholder="Ingrese patente del chasis" value={this.state.truck_plate}
                                        action={this._handleInput} name={'truck_plate'}
                                    />
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Patente Acoplado</label>
                                    <PlateInput
                                        placeholder="Ingrese patente del acoplado" value={this.state.trailer_plate}
                                        action={this._handleInput} name={'trailer_plate'}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row center"}>
                    <div className={"col s12"}>
                        <button onClick={this._submitForm}
                                className={`btn btn-shell z-depth-0 text-center ${this.state.ajaxInProgress ? 'disabled' : ''}`}>
                            Actualizar
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

TripProgrammingForm.defaultProps = {
    next_status: 'A0'
};


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/TripProgrammingForm.js